import {AfterViewInit, Component, OnDestroy, OnInit, Input, Output, EventEmitter} from "@angular/core";
import { EventManagerService } from '../../service/event-manager.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Constant } from '../../constant';
import { ModalBase } from "../modal.base.component";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: 'error-popup',
  templateUrl: "./error-popup.html",
  styleUrls: ["./error-popup.scss"]
})

export class ErrorPopupComponent extends ModalBase implements OnInit, OnDestroy  {
    @Output() result: EventEmitter<any> = new EventEmitter();
    @Input() iconImage: any = './assets/images/icons/error.png';
    public Constant = Constant;
    constructor(
        public eventManager: EventManagerService,
        public activeModal: NgbActiveModal,
        public ngModal: NgbModal
    ) {
        super(eventManager, activeModal)
    }
    dismiss() {
        super.dismiss();
        this.result.emit(true);
    }
}
